export default __webpack_public_path__ + "static/media/EsilioPic3.79d53b4b.png";